import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const getAllSellerDetailsApi = () =>
    Promise.resolve(axios.get(endpoints.getAllSellerDetails));
